import { loadStripe } from '@stripe/stripe-js';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// Your price ID from Stripe dashboard
export const SUBSCRIPTION_PRICE_ID = 'price_1Qyex4GsDYmqcnxAz2PZEx3J';
